import ReadMore from "@stimulus-components/read-more"

export class Controller extends ReadMore {
  static targets = ["toggleButton", "content"]

  connect() {
    super.connect()
    this.shouldHideButton()
    this.observer = new ResizeObserver(() => {
      this.shouldHideButton()
    })
    this.observer.observe(this.contentTarget)
  }

  shouldHideButton() {
    if (this.isOverflowing(this.contentTarget)) {
      this.toggleButtonTarget.classList.remove("hidden")
    } else {
      if (!this.open) {
        this.toggleButtonTarget.classList.add("hidden")
      }
    }
  }

  isOverflowing(e) {
    return e.offsetWidth + e.offsetHeight < e.scrollWidth + e.scrollHeight
  }
}
